import { EventLeaveReason } from 'types';
import { Card } from 'components';
import { CloseNewIcon } from 'components/Icon';

import styles from './PostEventCard.module.scss';

export type PostEventCardProps = {
  reason: EventLeaveReason;
  eventName: string;
  onDismiss?(): void;
};

const PostEventCard = ({ reason, eventName, onDismiss }: PostEventCardProps): JSX.Element => {
  const renderReason = () => {
    switch (reason) {
      case EventLeaveReason.ENDED:
        return <div className={styles.subtitle}>ended by host</div>;

      case EventLeaveReason.EXIT:
        return <div className={styles.subtitle}>you left</div>;

      default:
        return null;
    }
  };

  return (
    <Card className={styles.container}>
      <button type="button" className={styles.close} onClick={onDismiss}>
        <CloseNewIcon width={20} height={20} />
      </button>

      <div className={styles.title}>{eventName}</div>
      {renderReason()}
    </Card>
  );
};

export default PostEventCard;
